var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"page-not-found"}},[_c('h2',[_vm._v("Page not found")])])
}]

export { render, staticRenderFns }